export default __webpack_public_path__ + "static/MediaContentOne-b349a4bb65cf3b931e9dead8b77cd61e.webp";